import React from "react"
import ReactDOM from "react-dom"
import TagList from "./tag-list"

export default class TagListModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    const subcategories = elem.dataset.subcategories && JSON.parse(elem.dataset.subcategories)
    self.tags = []
    subcategories &&
      subcategories.forEach((subcategory) => {
        self.tags.push({
          label: subcategory.title,
          description: subcategory.description,
          amount: subcategory.productCount,
          url: subcategory.url,
          taxonomyFilter: subcategory.taxonomyFilter,
          checked: false,
        })
      })

    self.headline = elem.parentNode.querySelector("h1")
    self.description = elem.parentNode.querySelector("p")
    self.defaultHeadlineText = elem.dataset.mainCategoryTitle || self.headline.innerText
    self.defaultDescriptionText = elem.dataset.mainCategoryDescription || self.description.innerText
    self.defaultUrl = elem.dataset.mainCategoryUrl || window.location.pathname
    self.textKeys = elem.dataset.textKeys || {}
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <TagList
        modifier={self.elem.modifier}
        tags={self.tags}
        headline={self.headline}
        description={self.description}
        defaultHeadlineText={self.defaultHeadlineText}
        defaultDescriptionText={self.defaultDescriptionText}
        defaultUrl={self.defaultUrl}
        expandLabelText={self.textKeys.showAllTagsLabel || "se flere"}
      />,
      self.elem,
    )
  }
}
